const defaultOptions = {
  revalidate: false,
  tags: ['revalidate'],
  throwOnError: false,
  cache: 'force-cache',
};

export async function fetchServer(url, options = {}) {
  const { tags, revalidate, cache, throwOnError } = { ...defaultOptions, ...options };

  try {
    const fetchOptions = {};

    // если явно указали no-store → НЕ прокидываем next
    if (cache === 'no-store') {
      fetchOptions.cache = 'no-store';
    } else {
      fetchOptions.cache = cache;
      fetchOptions.next = { tags, revalidate };
    }

    const response = await fetch(url, fetchOptions);

    if (!response.ok) {
      throw new Error(`Failed to fetch data from ${url}: ${response.status} ${response.statusText}`);
    }

    const result = await response.json();

    return result;
  } catch (error) {
    console.error('Error fetching data from', url, ':', error);

    if (throwOnError) {
      throw error;
    }

    return null;
  }
}

export async function fetchMultipleServer(urls, options = {}) {
  const fetchPromises = Object.entries(urls).map(async ([key, url]) => {
    const data = await fetchServer(url, options);

    return [key, data];
  });

  const results = await Promise.all(fetchPromises);

  return Object.fromEntries(results);
}
